export const getUpdateInfo = (data) => {
    return {
        id: data.id,
        draftInProcess: data.draftInProcess,
        kickstarterDraftUrl: data.kickstarterDraftUrl,
        cid: data.cid,
        date: data.date,
        spots: data.spots
    }
}